import { webCore } from '@codes/web-core';

import type { AIStudioUploadBody, AIStudioUploadResponse } from '../types';

const BACKEND_ENDPOINT = import.meta.env.VITE_BACKEND_ENDPOINT?.toLowerCase();

if (!BACKEND_ENDPOINT) {
    throw new Error('VITE_BACKEND_ENDPOINT is not defined');
}

/**
 * Upload Google AI Studio code package
 * POST /products/{projectId}/upload { data: base64, title: string, version: string }
 * @param body - Upload request body with base64 data, title, version, projectId, and optional mocks
 * @returns Promise resolving to upload response
 */
export const uploadAIStudioCode = async (body: AIStudioUploadBody): Promise<AIStudioUploadResponse> => {
    const { projectId, mocks, ...uploadBody } = body;

    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/products/0/upload`,
        })
        .setParams({ projectId, ...(mocks !== undefined && { mock: mocks }) })
        .setBody(uploadBody)
        .execute<AIStudioUploadResponse>();

    return data;
};
